import ProsesProduksiForm from '../ProsesProduksiForm';

export default function ProsesProduksiEdit() {
  return <ProsesProduksiForm mode="edit" />;
}

